import {Box, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import type {PropsWithChildren} from 'react'
import {useListViewSelection} from '../ListView/SelectionContext'
import {testIdProps} from '@github-ui/test-id-props'

export const defaultContainerStyles: BetterSystemStyleObject = {
  px: 1,
  gridArea: 'status',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  gap: 2,
}

export const LeadingContent = ({sx: externalSx, children}: PropsWithChildren<{sx?: BetterSystemStyleObject}>) => {
  const {isSelectable} = useListViewSelection()
  const baseSx = merge<BetterSystemStyleObject>(defaultContainerStyles, {
    pl: isSelectable ? undefined : '12px',
  })
  const containerSx = externalSx ? merge<BetterSystemStyleObject>(baseSx, externalSx) : baseSx

  return (
    <Box className="listviewitem-leadingcontent" {...testIdProps('listview-item-leading-content')} sx={containerSx}>
      {children}
    </Box>
  )
}

try{ LeadingContent.displayName ||= 'LeadingContent' } catch {}